module.exports = __webpack_public_path__ + "img/exam_jan_2025_35gjtqre.fd10b3e2.jpg";